import { Country, Role, AddressType, SupplierPart } from 'app/profile/models/masterdata.model';
import { Language, MethodOfPayment, Entity, Currency, DocumentType, Region, ContextVerbiage, SupplierTax1099Box } from 'app/profile/models/supplier.model';
import { ToolCategory, ToolSubcategory } from 'app/profile/models/generic.model';
import { Dictionary } from 'underscore';
import { AgencyType, DiversityType, FormTemplate } from 'app/profile/models/onboarding.model';

export class MasterDataState {
    SupplierContactTypes: AddressType[];
    countries: Country[];
    roles: Role[];
    languages: Language[];
    regions: Region[];
    currencies: Currency[];
    entities: Entity[];
    documentTypes: DocumentType[];
    parts: SupplierPart[] | null;
    toolCategories: ToolCategory[];
    toolSubCategories: {[supplierCode: string]: ToolSubcategory[]};

    AgencyTypes: AgencyType[];
    DiversityTypes: DiversityType[];
    FormTemplate: FormTemplate;
    contextVerbiage: ContextVerbiage;
    Tax1099Boxes: SupplierTax1099Box[];
}

export const intitialState: MasterDataState = {
    SupplierContactTypes: null,
    countries: null,
    roles: null,
    languages: null,
    regions: null,
    currencies: null,
    entities: null,
    documentTypes: null,
    parts: null,
    toolCategories: null,
    toolSubCategories: null,
    AgencyTypes: null,
    DiversityTypes: null,
    FormTemplate: new FormTemplate(),
    contextVerbiage: null,
    Tax1099Boxes : null
}
